'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Tooltip = require('common/ui/view/behavior/tooltip');
const UserRepository = require('common/domain/repository/user');
const GroupAction = require('common/domain/action/group');
const GroupRepository = require('common/domain/repository/group');
const ModalView = require('common/ui/view/modal/index');
const GroupCreateView = require('balus/ui/view/global-menu/modal/group-create');
const Template = require('balus/ui/template/global-menu/index.hbs');
const NoGroupModalTemplate = require('balus/ui/template/global-menu/modal/no-group-modal.hbs');
const NoGroupModalFooterTemplate = require('balus/ui/template/global-menu/modal/no-group-modal-footer.hbs');
const GroupTemplate = require('balus/ui/template/global-menu/group.hbs');

const GroupView = Mn.View.extend({
    className: 'global-menu-group',
    template: GroupTemplate,
    events: {
        'click a': 'hideTooltip'
    },
    behaviors: {
        Tooltip: {
            behaviorClass: Tooltip,
            container: '.global-menu-tooltip'
        }
    },

    templateContext: function() {
        return {
            path: this.model.path()
        }
    },

    onRender: function() {
        const group = this.getOption('group');
        if(group && this.model.key.id == group.id) {
            this.$el.addClass('is-selected');
        }
    },

    hideTooltip: function() {
        this.$('[data-toggle="tooltip"]').tooltip('hide');
    }
});

const GroupListView = Mn.CollectionView.extend({
    childView: GroupView,
    childViewOptions: function() {
        return {
            group: this.getOption('group')
        }
    }
});

const NoGroupModalView = Mn.View.extend({
    template: NoGroupModalTemplate
});

const NoGroupModalFooterView = Mn.View.extend({
    template: NoGroupModalFooterTemplate,
    triggers: {
        'click .cancel': 'cancel'
    }
});

module.exports = Mn.View.extend({
    className: 'global-menu',
    template: Template,
    regions: {
        groups: '.group-list'
    },
    ui: {
        groupAddButton: '.global-menu-group-add'
    },
    events: {
        'click @ui.groupAddButton': 'addGroup'
    },

    serializeData: function() {
        const context = this.getOption('context');
        const isProduction = context.getAppInfo().isProduction();
        const loginUser = context.getUser();
        let canAddGroup = false;
        if(!isProduction) {
            canAddGroup = true;
        }

        if(isProduction && loginUser) {
            // 本番環境ではサイト管理者 または levii.co.jp ドメインのユーザのみ、グループ作成を行える
            if (loginUser.isSiteAdmin() || loginUser.isLeviiUser()) {
                canAddGroup = true;
            }
        }
        this.canAddGroup = canAddGroup;
    },

    showItemList: function(groupOrUser, options) {
        options = _.extend({}, options);
        $('.global-menu-item').removeClass('is-selected');
        if(options.isMyProjects) {
            $('.global-menu-my-projects').addClass('is-selected');
        }
        if(options.isMyActions) {
            $('.global-menu-my-actions').addClass('is-selected');
        }

        UserRepository.getLoginUser()
            .then(user => {
                if(user && user.id) {
                    GroupAction.fetchGroupsOnce({excludeMembers: true})
                        .then(() => {
                            const groups = GroupRepository.getGroups();
                            this.showChildView('groups', new GroupListView({
                                collection: groups,
                                group: groupOrUser
                            }));
                        });
                }
            });
    },

    addGroup: function() {
        if(this.canAddGroup) {
            const modal = new ModalView({
                title: i18n.t('balus_template_body_user:modal.group-create.title'),
                bodyView: new GroupCreateView(),
                onChildviewSave: function() {
                    this.disableButtons();
                    this.getOption('bodyView').setting()
                        .then(() => {
                            this.hide();
                        })
                        .catch(() => {
                            this.enableButtons();
                        })
                }
            });
            modal.show();
        } else {
            const modal = new ModalView({
                title: i18n.t('balus_template_body_user:modal.group-create.title'),
                bodyView: new NoGroupModalView(),
                footerView: new NoGroupModalFooterView()
            });
            modal.show();
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/global-menu/index.js